import { render, staticRenderFns } from "./solutionDetails4.vue?vue&type=template&id=113dd0f7&scoped=true&"
import script from "./solutionDetails4.vue?vue&type=script&lang=js&"
export * from "./solutionDetails4.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails4.vue?vue&type=style&index=0&id=113dd0f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113dd0f7",
  null
  
)

export default component.exports